// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dkMGo","expireSoon":"styles_expireSoon__VV_-8"};